import { Component, ElementRef, Input, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { WebapiService } from '../webapi.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
// import { download } from 'node_modulesbk/ionicons/icons';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.css']
})

export class ChatbotComponent implements OnInit {
  @ViewChild('chatContainer') private chatContainer!: ElementRef;
  @Input() type: string=''; // The string will be passed to this property

  welcome_msg="Welcome to your Logistics AI Assistant! I’m here to help you streamline operations, analyze data, and make smarter logistics decisions. Please choose what you’d like to analyze:"
  isOpen = false;
  userInput = '';
  selectedmodule:any;
  constructor(private service:WebapiService,private sanitizer: DomSanitizer,private router:Router)
  {



  }
  setmodule(x: number) {
    this.selectedmodule = this.config_list[x];
    const thisChatId = ++this.currentChatId;

    // Push the user's message indicating which module was selected
    this.messages.push({
        msgby: 'user',
        msg: this.sanitizer.bypassSecurityTrustHtml(`<div>${this.selectedmodule.sName}</div>`),
        timestamp: new Date(),
        chatId: thisChatId
    });

    // Push the bot's descriptive message
    this.messages.push({
        msgby: 'bot',
        msg: this.sanitizer.bypassSecurityTrustHtml(this.selectedmodule.sdescription),
        timestamp: new Date(),
        chatId: thisChatId
    });
    this.scrollToBottom();
}
  config_list:any=[]

handleDynamicClick(event: Event) {
    const target = event.target as HTMLElement;
 // alert(target.tagName+","+ target.classList.toString())

    if (target.tagName === 'SPAN' && target.classList.contains('btn')) {
        const index = target.getAttribute('data-index');
       // alert(index)
        if (index !== null) {
            this.setmodule(Number(index));

            
        }
    }
}
private botListAbortController: AbortController | null = null;

getall_botlist() {
    // Abort any previous bot list request
    if (this.botListAbortController) {
        this.botListAbortController.abort();
    }

    const newAbortController = new AbortController();
    this.botListAbortController = newAbortController;
    const signal = newAbortController.signal;

    const thisChatId = ++this.currentChatId;

    // Push a temporary loading message for the user's question
    const loadingMessageIndex = this.messages.length;
    this.messages.push({
        msgby: 'bot',
        msg: 'Checking for you...',
        timestamp: new Date(),
        chatId: thisChatId,
        isTemp: true
    });
    this.scrollToBottom();

    this.config_list = [];
    var action="getactivated_bot_config"
    if(this.type!="")
    {
        action="getactivated_bot_config_type"
    }
    this.service.postData({ type: this.type },action).then((result) => {
        if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
            this.botListAbortController = null; // Clear the controller on successful completion
            const temp: any = result;
            this.config_list = temp.data;
            let names = "";
            if(this.config_list.length>0)
            {

            
            this.config_list.forEach((element:any, index:any) => {
                names += `<span class="btn" style=" display: inline-block;word-break: break-word;line-height: 1.4;border-radius: 5px;border: thin solid gray;margin: 5px;background-color:#077dbc;color:#fff;padding:2px;cursor:pointer" data-index="${index}">${element.sName}</span>`;
            });
            const botMessageHtml = `<div style="margin-bottom:10px">${this.welcome_msg}</div> ${names}`;
            // Update the temporary message with the final response
            this.messages[loadingMessageIndex] = {
                msgby: 'bot',
                msg: this.sanitizer.bypassSecurityTrustHtml(botMessageHtml),
                timestamp: new Date(),
                chatId: thisChatId
            };
           }
           else{
             const botMessageHtml = `<div style="margin-bottom:10px">Sorry,No module yet configured to chat.</div> `;
            // Update the temporary message with the final response
            this.messages[loadingMessageIndex] = {
                msgby: 'bot',
                msg: this.sanitizer.bypassSecurityTrustHtml(botMessageHtml),
                timestamp: new Date(),
                chatId: thisChatId
            };
           }
            this.scrollToBottom();
        }
    }).catch(e => {
        if (e.name === 'AbortError') {
            console.log('Bot list request was aborted.');
            return;
        }
        // If there's an error and the message still exists, update it
        if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
            this.messages[loadingMessageIndex] = {
                msgby: 'bot',
                msg: 'Oops! Unable to load the bot list. Please try again later.',
                timestamp: new Date(),
                chatId: thisChatId
            };
            this.scrollToBottom();
        }
        this.botListAbortController = null;
    });
}
  // getall_botlist()
  // {
    
  //   this.messages.push({
  //         msgby: 'bot',
  //         msg: 'let me check..',
  //         timestamp: new Date()
  //       });


  //      // this.scrollToBottom();
  //   this.config_list=[]
  //        this.service.postData({type:'c'}, 'getactivated_bot_config').then((result) => {
  //                 var temp: any = result;
  //                  console.log(temp)
                  
                 
  //                 this.config_list =temp.data

  //                  var  botMessageHtml:any;

  //                  var names=""
  //                 this.config_list.forEach((element, index) => {
  //                     names += `<span class="btn" style=" display: inline-block;word-break: break-word;line-height: 1.4;border-radius: 5px;border: thin solid gray;margin: 5px;background-color:#077dbc;color:#fff;padding:2px;cursor:pointer" data-index="${index}">${element.sName}</span>`;
  //                 });

  //                 botMessageHtml = `<div style="margin-bottom:10px">${this.welcome_msg}</div> ${names}`;


  //                 console.log(botMessageHtml)

  //                this.messages[this.messages.length-1]={
  //                   msgby: 'bot',
  //                   msg: this.sanitizer.bypassSecurityTrustHtml(botMessageHtml),
  //                   timestamp: new Date()
  //                 };
  //               console.log(this.messages);
  //               this.scrollToBottom();
            
  //           }).catch(e => {
             

  //           });
            
            
  // }
  ngOnInit(): void {
    this.getall_botlist();
   
    }
  
  messages:any= [];

  scrollToBottom() {
  setTimeout(() => {
    const el = this.chatContainer.nativeElement;
    el.scrollTop = el.scrollHeight;
  }, 0); // Wait for DOM to render
}
  toggleChat() {
    this.isOpen = !this.isOpen;
  }
  private currentAbortController: AbortController | null = null;
// A map to store and manage timeouts for each chat session
loadingTimeouts = new Map<number, any>();
// This will hold a unique ID for the current chat session
currentChatId: number = 0;

startover() {
    // 1. Cancel any ongoing API requests from the previous session.
    if (this.currentAbortController) {
        this.currentAbortController.abort();
        this.currentAbortController = null; // Clear the controller reference
    }

    // 2. Clear any pending timeouts to prevent old "hang on" messages from appearing.
    this.loadingTimeouts.forEach(timeout => clearTimeout(timeout));
    this.loadingTimeouts.clear();
    
    // 3. Increment the chat ID to start a new, clean session.
    this.currentChatId++;
    
    // ... (rest of your existing logic to set up and push the welcome message) ...

    let botMessageHtml: any;
    let names = "";
    this.config_list.forEach((element:any, index:any) => {
                names += `<span class="btn" style=" display: inline-block;word-break: break-word;line-height: 1.4;border-radius: 5px;border: thin solid gray;margin: 5px;background-color:#077dbc;color:#fff;padding:2px;cursor:pointer" data-index="${index}">${element.sName}</span>`;
            });

    botMessageHtml = `<div style="margin-bottom:10px">${this.welcome_msg}</div> ${names}`;
    console.log(botMessageHtml);

    this.messages.push({
        msgby: 'bot',
        msg: this.sanitizer.bypassSecurityTrustHtml(botMessageHtml),
        timestamp: new Date(),
        chatId: this.currentChatId
    });
    this.scrollToBottom();
}

 chartData = {
    "chartType": "ColumnChart",
    "dataTable": [
        ["Lane", "Backlog (kg)"],
        ["HKG - GDL", 90468.0],
        ["HKG - HKG", 40437.5],
        ["HKG - ELP", 28905.5],
        ["HKG - DFW", 26141.5],
        ["HAN - HKG", 21339.0]
    ],
    "options": {
        "title": "Top 5 Lanes by Backlog Weight",
        "hAxis": {
            "title": "Lane"
        },
        "vAxis": {
            "title": "Backlog Weight (kg)",
            "format": "#,###"
        },
        "legend": {
            "position": "none"
        }
    }
};

chartlist:any=[]

chat(q: string) {
    if (!this.selectedmodule) {
        this.messages.push({
            msgby: 'bot',
            msg: 'Please select a module to begin our conversation.',
            timestamp: new Date()
        });
        return;
    }

    var cleaned = this.sanitizeUserInput(q);

        const thisChatId = ++this.currentChatId;

    if (!this.isValidUserInput(cleaned)) {
        
     // alert("Invalid input detected!");
      this.messages.push({
            msgby: 'bot',
            msg: 'Please enter a valid query.No html,js tags and special characters are allowd',
            timestamp: new Date()
        });
      return;
    }

    // 1. If a previous request is still running, abort it.
    if (this.currentAbortController) {
        this.currentAbortController.abort();
    }
    
    // 2. Create a new AbortController for this request.
    const newAbortController = new AbortController();
    this.currentAbortController = newAbortController;
    const signal = newAbortController.signal;

    this.messages.push({
        msgby: 'user',
        msg: cleaned,
        timestamp: new Date(),
        chatId: thisChatId
    });

    const loadingMessageIndex = this.messages.length;
    this.messages.push({
        msgby: 'bot',
        msg: 'Checking for you...',
        timestamp: new Date(),
        chatId: thisChatId,
        isTemp: true
    });
    this.scrollToBottom();

    var prompt = this.selectedmodule.sotherprompt;
    const fixedJSON = JSON.parse(this.selectedmodule.sjsonconfig).replace(/\bNaN\b/g, 'null');
    var sjsonconfig = fixedJSON;
    prompt += "CSV FILE METADATA:" + JSON.stringify(JSON.parse(fixedJSON));
    prompt += " Technical instruction to generate python code : " + this.selectedmodule.stechprompt;

    this.loadingTimeouts.set(thisChatId, setTimeout(() => {
        if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
            this.messages[loadingMessageIndex].msg = 'This is taking a bit longer than usual. Please hang on...';
            this.scrollToBottom();
        }
    }, 10000));

    this.service.postData({'query': cleaned, 'prompt': prompt, 'timeout': 180}, 'analyze_new_timeout')
        .then((result) => {
            clearTimeout(this.loadingTimeouts.get(thisChatId));
            this.loadingTimeouts.delete(thisChatId);

            console.log(this.cleanGoogleChartTag(result.natural_response));
            if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {

                 var res:any=this.extractAndRemoveCharts(this.cleanGoogleChartTag(result.natural_response))
                 console.log(res.data);
                 console.log(res.cleanedHtml);
                this.messages[loadingMessageIndex] = {
                    msgby: 'bot',
                    msg: this.sanitizer.sanitize(SecurityContext.HTML,res.cleanedHtml),
                    download:result.json_data,
                    download_json:result.json_result,

                    charts:res.data,
                    timestamp: new Date(),
                    chatId: thisChatId
                };
                this.scrollToBottom();
            }
        })
        .catch(res => {
            if (res.name === 'AbortError') {
                console.log('Request was aborted by a new user message or start over.');
                clearTimeout(this.loadingTimeouts.get(thisChatId));
                this.loadingTimeouts.delete(thisChatId);
                return;
            }
            
            console.error('API Error:', res);
            clearTimeout(this.loadingTimeouts.get(thisChatId));
            this.loadingTimeouts.delete(thisChatId);

            if (this.messages[loadingMessageIndex]?.chatId === thisChatId) {
                this.messages[loadingMessageIndex] = {
                    msgby: 'bot',
                    msg: 'Oops! Something went wrong. Please try again.',
                    timestamp: new Date(),
                    chatId: thisChatId
                };
                this.scrollToBottom();
            }
        })
        .finally(() => {
            this.currentAbortController = null;
        });
}

  loadingTimeout:any;
  hasResponded=false;

  //  chat(q){


  //    if(!this.selectedmodule)
  //      {

  //         this.messages.push({
  //         msgby: 'bot',
  //         msg: 'Please select the module..',
  //         timestamp: new Date()
  //       });
  //       return;

  //      }
  //     this.messages.push({
  //         msgby: 'bot',
  //         msg: 'let me check..',
  //         timestamp: new Date()
  //       });

  //        this.scrollToBottom();

  //       var prompt = this.selectedmodule.sotherprompt;
  //           const fixedJSON = JSON.parse(this.selectedmodule.sjsonconfig).replace(/\bNaN\b/g, 'null');

  //       var sjsonconfig = fixedJSON;
  //       prompt += "CSV FILE METADATA:"+ JSON.stringify(JSON.parse(fixedJSON));
  //       prompt += " Technical instruction to generate python code : "+this.selectedmodule.stechprompt
  //       this.loadingTimeout = setTimeout(() => {
  //         if (!this.hasResponded) {
  //           this.messages[this.messages.length - 1] = {
  //             msgby: 'bot',
  //             msg: "<p>This is taking a bit longer than usual. Please hang on...<p>",
  //             timestamp: new Date()
  //           };
  //           this.messages.push({
  //             msgby: 'bot',
  //             msg: "let me check..",
  //             timestamp: new Date()
  //           })
  //         }
  //       }, 10000); // 20 seconds
  //     this.service.postData({'query':q,'prompt':prompt,'timeout':90}, 'analyze_new_timeout').then((result) => {
  //      console.log(result); 
  //        clearTimeout(this.loadingTimeout);  // Stop 20s message if still pending

  //        this.messages[this.messages.length-1]={
  //         msgby: 'bot',
  //         msg: result.natural_response,
  //         timestamp: new Date()
  //       };
  //       this.scrollToBottom();

  //   }).catch(res=>{
  //     console.log(res);
  //       clearTimeout(this.loadingTimeout);  // Stop 20s message if still pending

  //   });
  
  //  }


  sendMessage() {
    console.log(this.userInput)
    if (this.userInput.trim() !== '') {
      // this.messages.push({
      //   msgby: 'user',
      //   msg: this.userInput,
      //   timestamp: new Date()
      // });

      this.chat( this.userInput);
      // const botResponse = `You said: ${this.userInput}`;
      // setTimeout(() => {
      //   this.messages.push({
      //     msgby: 'bot',
      //     msg: botResponse,
      //     timestamp: new Da
      // te()
      //   });
      // }, 500);

      this.userInput = '';
    }
  }

  cleanGoogleChartTag(htmlString: string): string {
  // Regex to find the <google-chart> tag and its data attribute.
  // The 's' flag allows '.' to match newline characters.
  const regex = `/(<google-chart\s+\[data\]=")([^"]*)("><\/google-chart>)/s`;

  // Use the replace method with a replacer function to capture and clean the content.
  return htmlString.replace(regex, (match, p1, p2, p3) => {
    // p1: The opening part of the tag (e.g., "<google-chart [data]=").
    // p2: The raw content of the [data] attribute (the data object string).
    // p3: The closing part of the tag (e.g., "></google-chart>").

    // Clean the captured data by replacing all whitespace characters (\s)
    // with an empty string globally (g).
    const cleanedData = p2.replace(/\s+/g, '');

    // Reconstruct the tag with the cleaned data and return it.
    return `${p1}${cleanedData}${p3}`;
  });

  
}


 extractAndRemoveCharts(htmlString:any) {
    const dataArray = [];
    // Regex to find the data attribute content more robustly
    const extractRegex = /<google-chart\s+\[data\]="([^"]*)"[^>]*>/gs;
    let match;

    while ((match = extractRegex.exec(htmlString)) !== null) {
        let rawDataString = match[1];

        try {
            // Replace known HTML entities and single quotes
            rawDataString = rawDataString.replace(/&quot;/g, '"');
            rawDataString = rawDataString.replace(/'/g, '"');

            const chartData = JSON.parse(rawDataString);
            dataArray.push(chartData);
        } catch (e) {
            console.error('Failed to parse JSON data from a <google-chart> tag:', e);
            console.error('Problematic string:', rawDataString);
        }
    }
    
    // Regex to remove the entire <google-chart> tag
    const removeRegex = `/<google-chart\s+\[data\]="[^"]*"[^>]*><\/google-chart>/gs`;
    const cleanedHtml = htmlString.replace(removeRegex, '').trim();

    return {
        data: dataArray,
        cleanedHtml: cleanedHtml,
    };
}
 sanitizeUserInput(input: string): string {
  if (!input) return "";

  // 1. Trim whitespace
  let sanitized = input.trim();

  // 2. Remove HTML tags
  sanitized = sanitized.replace(/<[^>]*>/g, "");

  // 3. Block suspicious characters often used in injections
  sanitized = sanitized.replace(/[{};$<>]/g, "");

  // 4. Limit length (avoid DoS by very large input)
  const MAX_LENGTH = 500;
  if (sanitized.length > MAX_LENGTH) {
    sanitized = sanitized.substring(0, MAX_LENGTH);
  }

  return sanitized;
}

// Validation example
  isValidUserInput(input: string): boolean {
  if (!input) return false;

  // Reject empty or too short input
  if (input.trim().length < 2) return false;

  // Reject if contains SQL/JS keywords (basic filter)
  const blacklist = /(SELECT|INSERT|DELETE|UPDATE|DROP|SCRIPT|ALERT|ONERROR)/i;
  if (blacklist.test(input)) return false;

  return true;
}
downloadJSONToCSV(datas: string, filename: string = 'responseresult.csv'): void {
    var data = JSON.parse(datas);
  if (!data || !data.length) {
    console.warn('No data to export');
    return;
  }

  // Extract headers from first object
  const headers = Object.keys(data[0]);

  // Build CSV rows
  const csvRows: string[] = [];

  // Add header row
  csvRows.push(headers.join(','));

  // Add data rows
  for (const item of data) {
    const row = headers.map(header => {
      let val = item[header] ?? ''; // handle null/undefined
      val = String(val).replace(/"/g, '""'); // escape double quotes
      return `"${val}"`;
    });
    csvRows.push(row.join(','));
  }

  // Create CSV string
  const csvString = csvRows.join('\n');

  // Create Blob for download
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);

  // Create link element and trigger download
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
isCSVDownloadableFromJSON(jsonString: string): boolean {
  try {
    // 1️⃣ Parse JSON safely
    const data = JSON.parse(jsonString);

    // 2️⃣ Must be an array
    if (!Array.isArray(data) || data.length === 0) {
      console.warn("❌ JSON is not a valid non-empty array.");
      return false;
    }

    // 3️⃣ Each item must be a plain object
    const isObjectArray = data.every(
      (item) => item && typeof item === "object" && !Array.isArray(item)
    );
    if (!isObjectArray) {
      console.warn("❌ JSON must contain plain objects only.");
      return false;
    }

    // 4️⃣ Each object must have at least one key
    const hasKeys = data.every((obj) => Object.keys(obj).length > 0);
    if (!hasKeys) {
      console.warn("❌ Some objects have no properties.");
      return false;
    }

    // ✅ All checks passed
    return true;
  } catch (error) {
    console.error("❌ Invalid JSON format:", error);
    return false;
  }
}

openchat()
{
   this.router.navigateByUrl("/aichat")
}
}
